import readStringEnv from './services/readStringEnv';

function getZenloopOrgId(): string | null {
  return readStringEnv(process.env.NEXT_PUBLIC_ZENLOOP_ORG_ID);
}

export default getZenloopOrgId;
